// extracted by mini-css-extract-plugin
export default {"editButton":"cashAllowance_editButton__81TA5","TableBody":"cashAllowance_TableBody__2haDZ"};